import Form from "react-bootstrap/Form";
import {ChangeEvent, Dispatch, SetStateAction} from "react";
import {ProductInSearchParamType} from "../interface";
import {SubmitHandler, useForm} from "react-hook-form";
import useGoToNavigation from "../../../../../util/useGotoNavigation";

interface PropsType {
    searchParam: ProductInSearchParamType
    setSearchParam: Dispatch<SetStateAction<ProductInSearchParamType>>
}

export default function Filter({searchParam, setSearchParam}: PropsType) {
    const {goToNavigation} = useGoToNavigation();

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const onCheckHandler = (e: ChangeEvent<HTMLInputElement>) => {
        const {name} = e.target

        let value = ""
        if (name === "statusCodeList1") {
            value = "N"
        } else {
            value = "Y"
        }

        const currentList = getValues("statusCodeList")
        const flag = currentList.some(el => el == value)

        let list;
        if (flag) {
            list = currentList.filter(el => el != value)
        } else {
            list = [...currentList, value]
        }

        setValue("statusCodeList", list)
    }

    const onSubmit: SubmitHandler<ProductInSearchParamType> = (submitData) => {
        goToNavigation(`product/list?pageNo=1`, {}, false)
        setSearchParam({...submitData, pageNo: 1});
    };

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">제품 검색</h3>
            <div className="filter_toolbar"></div>
        </div>
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">상태 (외부)</label>
                    <Form.Check
                        inline
                        label="활성"
                        type="checkbox"
                        id="inline-checkbox-1"
                        name="statusCodeList1"
                        checked={watch("statusCodeList").includes("N")}
                        onChange={onCheckHandler}
                    />
                    <Form.Check
                        inline
                        label="비활성"
                        type="checkbox"
                        id="inline-checkbox-2"
                        name="statusCodeList2"
                        checked={watch("statusCodeList").includes("Y")}
                        onChange={onCheckHandler}
                    />
                </div>
            </div>
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">검색어</label>
                    <select className="form-select"
                            {...register("keywordType")}>
                        <option value={"1"}>전체</option>
                        <option value={"2"}>벤더</option>
                        <option value={"3"}>카테고리</option>
                        <option value={"4"}>품목</option>
                        <option value={"5"}>규격</option>
                        <option value={"6"}>중분류</option>
                        <option value={"7"}>대분류</option>
                    </select>
                    <input type="text"
                           className="form-control"
                           {...register("keyword")}
                    />
                    <button className="btn btn-info btn_search">
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                    </button>
                </div>
            </div>
        </form>
    </div>
}